<div class="first-registration-container">
  <p class="">{{ loyaltyConnectAccountThanksForBeignMemberString }}</p>
  <div class="first-login-form">
    <p class="use-first-creds">
      {{ loyaltyConnectAccountUseYourFirstCredentialsString }}
      <span> {{ loyaltyAmadeusPlusMeString }} </span>
      {{ credentials }}
    </p>

    <form [formGroup]="loginLoyaltyForm" (ngSubmit)="bindAgent()">
      <div class="input_container">
        <label for="number" i18n="@@loyalty-login-form.loyaltyConnectAccountFormMembershipId">Membership ID</label>
        <input
          id="number"
          formControlName="number"
          type="text"
          class="form-control number-validation required"
          required
        />
      </div>
      <div class="input_container">
        <label for="password" i18n="@@loyalty-login-form.loyaltyConnectAccountFormPassword">Password</label>
        <input id="password" formControlName="password" type="password" class="form-control required" required />
      </div>

      <div class="input_container">
        <button
          class="btn btn-primary loginFirst"
          type="submit"
          id="loginFirst"
          style="width: 100%;"
          [disabled]="loginLoyaltyForm.invalid"
          i18n="@@loyalty-login-form.loyaltyConnectAccountFormSignInButton"
        >
          Login
        </button>
      </div>
    </form>

    <div class="first-reg-link-container back">
      <div class="text-center">
        <a
          id="showEnrollPage"
          class="link"
          [innerHTML]="loyaltyConnectAccountIWantNewOne"
          (click)="goToEnrollForm('enrollment')"
        >
          <svg>
            <use href="'/assets/images/svg_ico/icons.svg#ic_keyboard_arrow_left'"></use>
          </svg>
        </a>
      </div>
    </div>
  </div>
</div>
